/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryTypeWithRelations } from '../../models/inventory-type-with-relations';

export interface Find$Params {
  filter?: any;
}

export function find(http: HttpClient, rootUrl: string, params?: Find$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InventoryTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, find.PATH, 'get');
  if (params) {
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InventoryTypeWithRelations>>;
    })
  );
}

find.PATH = '/inventory-types';
